import classnames from 'classnames'
import { ComponentChildren } from 'preact'
import DropdownList from './DropdownList'
import Dropdown from './index'
import { GroupedItemsList, ItemsList } from './interfaces'

interface Props {
  type?: string
  align: string
  trigger: ComponentChildren
  items: ItemsList | GroupedItemsList
  displayListUpwards?: boolean
  hasSearch?: boolean
  triggerClass?: string
  disabled?: boolean
  children?: ComponentChildren
  newStyle?: boolean
  closeOnDropdownClick?: boolean
  className?: string
  searchPlaceholderText?: string
  searchIconWidth?: number
  searchIconHeight?: number
  fullWidth?: boolean
  onTriggerClicked?: ({ close }: { close: () => void }) => JSX.Element
}

const DropdownControl = ({
  type,
  align,
  trigger,
  items,
  displayListUpwards,
  hasSearch,
  triggerClass,
  disabled,
  newStyle,
  className,
  closeOnDropdownClick,
  searchPlaceholderText,
  searchIconWidth,
  searchIconHeight,
  fullWidth,
  onTriggerClicked
}: Props) => {
  return (
    <Dropdown
      closeOnDropdownClick={closeOnDropdownClick ?? false}
      popupName='control-dropdown'
      // eslint-disable-next-line @gorazdo/preact/prefer-classname
      class={classnames(className, 'control-dropdown', {
        'control-dropdown--brand': newStyle
      })}
      trigger={trigger}
      triggerClass={classnames(triggerClass, {
        'control-dropdown--full-width': fullWidth
      })}
      disabled={disabled}
    >
      {typeof onTriggerClicked === 'function'
        ? ({ close }: { close: () => void }) => {
          return onTriggerClicked({ close })
        }
        : <DropdownList
            displayListUpwards={displayListUpwards}
            type={type}
            align={align}
            items={items}
            hasSearch={hasSearch ?? false}
            searchPlaceholderText={searchPlaceholderText}
            searchIconWidth={searchIconWidth}
            searchIconHeight={searchIconHeight}
          />}
    </Dropdown>
  )
}

export default DropdownControl
